import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import EntityTable from '../../components/workspace/EntityTable';
import { useApi } from '../../lib/api';
import { useWorkspace } from '../../lib/workspace';

const COLUMNS = [
  { key: 'name',    label: 'Name' },
  { key: 'state',   label: 'State' },
  { key: 'country', label: 'Country' },
];

const FIELDS = [
  { name: 'name',    label: 'Name',    required: true, maxLen: 200 },
  { name: 'country', label: 'Country', maxLen: 100 },
  { name: 'state',   label: 'State',   maxLen: 100 },
];

export default function Locations() {
  const { appId } = useParams();
  const api = useApi();
  const { canWrite } = useWorkspace();

  const fetcher = useCallback(() => api.locations.list(appId), [api, appId]);

  return (
    <EntityTable
      title="Locations"
      fetcher={fetcher}
      columns={COLUMNS}
      formFields={FIELDS}
      onCreate={(body)      => api.locations.create(appId, body)}
      onUpdate={(id, body)  => api.locations.update(appId, id, body)}
      onDelete={(id)        => api.locations.remove(appId, id)}
      canWrite={canWrite}
      emptyMessage="No locations yet. Add the first office or site to get started."
    />
  );
}
